import { render, staticRenderFns } from "./MySelect.vue?vue&type=template&id=62e4702a&scoped=true"
import script from "./MySelect.vue?vue&type=script&lang=js"
export * from "./MySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e4702a",
  null
  
)

export default component.exports